import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Libs
import 'bootstrap'
import Dayjs from 'vue-dayjs'
import './assets/scripts/main'
import vSelect from 'vue-select'
import * as filters from './lib/filters'
import SimpleVueValidation from 'simple-vue-validator'

// Styles
import 'vue-select/dist/vue-select.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/styles/main.css'

// Filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

store.commit('SET_FROM_LOCAL_STORAGE')

Vue.use(Dayjs)
Vue.component('v-select', vSelect)
Vue.use(SimpleVueValidation)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')